import { ProductRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';
import _ from 'lodash';

class ProductService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new ProductRouteService());
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	linkProduct(product, sourceOfChange) {
		var url = this.routeService.linkProduct(product, sourceOfChange);
		return this.apiClient.put(url);
	}

	setProductActivity(product, sourceOfChange) {
		var url = this.routeService.setProductActivity(product, sourceOfChange);
		return this.apiClient.put(url);
	}

	createBatch(resource, sourceOfChange) {
		var url = this.routeService.createBatch(sourceOfChange);
		return this.apiClient.post(url, resource);
	}

	updateProducts(products, sourceOfChange) {
		var url = this.routeService.updateProducts(sourceOfChange);
		return this.apiClient.put(url, products);
	}
}

export default ProductService;
